import React from "react";
const EventManagement = React.lazy(() => import('./EventManagement'));

export const eventManagementConfig = [
    {
        path: '/apps/event',
        element:<EventManagement/>,
        roleAccess: ['EVENT.USER'],
    },
    {
        path: '/apps/event/:page',
        element: <EventManagement/>,
        roleAccess: ['EVENT.USER'],
    },
    {
        path: '/apps/event/:page/:action',
        element: <EventManagement/>,
        roleAccess: ['EVENT.USER'],
    }
];